// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var FlowchartAlt = function FlowchartAlt(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.3 10.4V7.8H3.6V5.6h1.6V1.4H1v4.2h1.7v3.1h9.7v1.7h-1.6v4.2H15v-4.2z"
    }))
  );
};

export default FlowchartAlt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/FlowchartAlt.js
// module id = 1011
// module chunks = 0